export default "__VITE_ASSET__D1xVS5ls__"